import { uiSize } from '@utils'

function CloseCircleIcon() {
  return (
    <svg width={uiSize(15)} height={uiSize(15)} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.1'>
      <circle cx='12' cy='12' r='9' />
      <path d='M8.5 8.5l7 7M15.5 8.5l-7 7' />
    </svg>
  )
}

export default CloseCircleIcon
